import { Component } from '@angular/core';

@Component({
    selector: 'cdp-job-reassign-warning',
    templateUrl: './job-reassign-warning.component.html',
    standalone: false
})
export class JobReassignWarningComponent {}
